// Object with one or more passed fields (required as unique) already exist
export const getErrorMessage = (message: string) => {
  switch (message) {
    case "Object with one or more passed fields (required as unique) already exist":
      return "File with such language and type combination already exists.";
    case "field required":
      return "Some fields are missing.";
    default:
      return message;
  }
};
